import { createContext } from 'react';

const ResizeWatcherContext = createContext(null);
/**
 * A variant of ResizeObserver that acts similarly to add/removeEventListener.
 */
class ResizeWatcher {
    constructor() {
        this.resizeObserver = new ResizeObserver((entries) => this.onResize(entries));
        this.callbacks = new Map();
    }
    onResize(entries) {
        entries.forEach((entry) => {
            const callbacks = this.callbacks.get(entry.target);
            if (callbacks) {
                callbacks.forEach((cb) => cb(entry.target));
            }
        });
    }
    watch(element, callback) {
        var _a;
        const cbs = (_a = this.callbacks.get(element)) !== null && _a !== void 0 ? _a : [];
        cbs.push(callback);
        this.callbacks.set(element, cbs);
        this.resizeObserver.observe(element);
    }
    unwatch(element, callback) {
        var _a;
        this.resizeObserver.unobserve(element);
        const cbs = (_a = this.callbacks.get(element)) !== null && _a !== void 0 ? _a : [];
        const idx = cbs.indexOf(callback);
        if (idx > -1) {
            cbs.splice(idx, 1);
        }
    }
}

export { ResizeWatcher, ResizeWatcherContext };
